import { useCallback, useEffect, useRef, useState } from "react";

const Breadcrumps = ({children}) => {
    return (
      <nav className="breadcrumbs">
              { children }
      </nav>
    );
};

export default Breadcrumps;
